// extracted by mini-css-extract-plugin
export var bodyText = "styles-module--bodyText--defd8";
export var ctaButton = "styles-module--ctaButton--a0089";
export var headline = "styles-module--headline--d3cec";
export var iconWrapper = "styles-module--iconWrapper--8260c";
export var logo = "styles-module--logo--9ca75";
export var modal = "styles-module--modal--d4fbb";
export var root = "styles-module--root--3843e";
export var wrapper = "styles-module--wrapper--39c80";